import { MdlDialogReference, MdlDialogService } from '@angular-mdl/core';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Settings } from '../../../../core';
import { Report } from '../../../../documents';
import { Project } from '../../../shared';
import { UploadedDocumentsStorage } from '../../storages/uploaded-documents-storage';
import { UploadDialogData, UPLOAD_DLG_DATA_TOKEN } from '../base/upload-dialog-data';
import { SitesData } from '../form-fields/sites-select.component';
import { SiteSpecificUploadDialogBase } from './site-specific-upload-dialog-base';
import { serializeDateOnly } from '../../../../core/serializers';

@Component({
    selector: 'app-site-communications-upload',
    template: require('./site-communications-upload.component.html'),
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SiteCommunicationsUploadComponent extends SiteSpecificUploadDialogBase {
    public readonly projectControl: FormControl;
    public readonly letterNumberControl: FormControl;
    public readonly titleControl: FormControl;
    public readonly sitesFormGroup: FormGroup;

    public readonly allowedFileExtensions: string[];
    public sitesData: SitesData;

    constructor(
        protected readonly dialog: MdlDialogReference,
        protected readonly dialogService: MdlDialogService,
        @Inject(UPLOAD_DLG_DATA_TOKEN) protected readonly dialogData: UploadDialogData<Report>,
        uploadedDocumentsStorage: UploadedDocumentsStorage,
        protected readonly settings: Settings
    ) {
        super(dialog, dialogService, uploadedDocumentsStorage, uploadedDocumentsStorage);

        this.projectControl = new FormControl();
        this.letterNumberControl = new FormControl();
        this.titleControl = new FormControl();
        this.sitesFormGroup = new FormGroup({});

        this.editorForm.addControl('project', this.projectControl);
        this.editorForm.addControl('letterNumber', this.letterNumberControl);
        this.editorForm.addControl('title', this.titleControl);
        this.editorForm.addControl('sites', this.sitesFormGroup);

        this.allowedFileExtensions = settings.uploadedFileExtensionsByCategoryId(dialogData.category.categoryId);
    }

    public onSitesChange(sitesData: SitesData) {
        this.sitesData = sitesData;
    }

    public async addFiles() {
        const project = (this.projectControl.value as Project[])[0];
        let message = '';
        if (this.sitesData.allSites) {
            message = `This communication will be viewable by all investigators at all sites for project ${project.zcProjectNumber}. Proceed?`;
        } else {
            const sitesDescription = this.sitesData.selectedSites.map(s => `${s.siteNum} - ${s.investigatorFullName}`).join('<br/>');
            const sitesDescriptionHtml = `<div style="max-height: 40vh;overflow: auto;">${sitesDescription}</div>`;
            message = `This communication will be viewable by all investigators at the following site(s) for project ${project.zcProjectNumber}. Proceed?<br/><br/>${sitesDescriptionHtml}`;
        }

        const siteLimitdate = serializeDateOnly(this.sitesData.siteLimitDate);

        const documentMetadata = {
            subprotocolId: project.subProtocolId,
            selectedSites: this.sitesData.selectedSites.map(s => s.siteId),
            allSites: this.sitesData.allSites,
            siteLimitDate: siteLimitdate,
            letterNumber: this.letterNumberControl.value,
            title: this.titleControl.value,
        };

        super.addFiles(message, this.dialogData.category.categoryId, documentMetadata);
    }
}
